(() => {
  const roots = document.querySelectorAll("[data-giveaway-root]")
  for (const root of roots) {
    if (!(root instanceof HTMLElement) || root.dataset.giveawayReady === "true") continue
    root.dataset.giveawayReady = "true"
    bindGiveaway(root)
  }

  async function bindGiveaway(root) {
    const status = root.querySelector("[data-giveaway-status]")
    const form = root.querySelector("[data-giveaway-form]")
    const submit = root.querySelector("[data-giveaway-submit]")
    const alert = root.querySelector("[data-giveaway-alert]")
    if (!(status instanceof HTMLElement) || !(form instanceof HTMLFormElement) || !(submit instanceof HTMLButtonElement)) return
    bindDialogs(root)
    const apiBase = (root.dataset.apiBase || "").replace(/\/$/, "")
    const slug = root.dataset.slug || ""
    let token = null
    let open = false

    const setStatus = (message) => {
      status.textContent = message
    }
    const showAlert = (message) => {
      if (!(alert instanceof HTMLElement)) return
      alert.textContent = message
      alert.hidden = !message
    }
    const clearErrors = () => {
      for (const node of root.querySelectorAll("[data-error-for]")) {
        if (node instanceof HTMLElement) {
          node.textContent = ""
          node.hidden = true
        }
      }
      for (const input of form.querySelectorAll("input")) input.removeAttribute("aria-invalid")
    }
    const showErrors = (errors) => {
      if (!errors) return
      for (const [name, message] of Object.entries(errors)) {
        const node = root.querySelector(`[data-error-for="${name}"]`)
        const input = form.elements.namedItem(name)
        if (node instanceof HTMLElement) {
          node.textContent = String(message)
          node.hidden = false
        }
        if (input instanceof HTMLInputElement) input.setAttribute("aria-invalid", "true")
      }
    }

    form.addEventListener("submit", async (event) => {
      event.preventDefault()
      if (!open || !token) return
      clearErrors()
      showAlert("")
      submit.disabled = true
      submit.setAttribute("aria-busy", "true")
      submit.textContent = "Submitting…"
      const data = new FormData(form)
      try {
        const response = await fetch(`${apiBase}/api/public/entries`, {
          method: "POST",
          headers: { Accept: "application/json", "Content-Type": "application/json" },
          body: JSON.stringify({
            slug,
            fullName: String(data.get("fullName") || ""),
            email: String(data.get("email") || ""),
            instagram: String(data.get("instagram") || ""),
            rules: data.get("rules") === "on",
            marketing: data.get("marketing") === "on",
            website: String(data.get("website") || ""),
            formIssuedAt: token.issuedAt,
            formNonce: token.nonce,
            formMac: token.mac,
          }),
        })
        const result = await response.json()
        if (response.status === 201 && result.ok) {
          const entry = root.querySelector("[data-giveaway-entry]")
          const done = root.querySelector("[data-giveaway-done]")
          if (entry instanceof HTMLElement) entry.hidden = true
          if (done instanceof HTMLElement) {
            done.hidden = false
            const heading = done.querySelector("h2")
            if (heading instanceof HTMLElement) heading.focus()
          }
          return
        }
        showErrors(result.fieldErrors)
        showAlert(result.formError || "The entry could not be saved.")
      } catch {
        showAlert("The entry could not be saved. Check the connection and try again.")
      }
      submit.disabled = false
      submit.removeAttribute("aria-busy")
      submit.textContent = "Enter Giveaway"
    })

    if (!apiBase || !slug) {
      setStatus("This page is missing its giveaway service address.")
      return
    }
    try {
      const response = await fetch(`${apiBase}/api/public/giveaways/${encodeURIComponent(slug)}`, {
        headers: { Accept: "application/json" },
      })
      const payload = await response.json()
      if (!response.ok || payload.state === "unavailable" || payload.state === "forbidden") {
        setStatus("The giveaway form is unavailable. Refresh the page in a moment.")
        return
      }
      applyPublicCopy(root, payload)
      if (payload.state === "open" && payload.token) {
        token = payload.token
        open = true
        submit.disabled = false
        submit.textContent = "Enter Giveaway"
        setStatus("Entries are open. One entry per person.")
        return
      }
      submit.textContent = "Entries are not open yet"
      setStatus(closedMessage(payload.state))
    } catch {
      setStatus("The giveaway form is unavailable. Check the connection and refresh the page.")
    }
  }

  function bindDialogs(root) {
    let opener = null
    const dialogs = [...root.querySelectorAll("[data-giveaway-dialog]")].filter((node) => node instanceof HTMLDialogElement)

    const unlock = () => {
      if (root.querySelector("dialog[open]")) return
      document.documentElement.style.overflow = ""
      if (opener instanceof HTMLElement) opener.focus()
    }

    for (const dialog of dialogs) {
      dialog.addEventListener("click", (event) => {
        if (event.target === dialog) dialog.close()
      })
      dialog.addEventListener("close", unlock)
      dialog.addEventListener("cancel", () => {
        dialog.close()
      })
    }

    root.addEventListener("click", (event) => {
      const target = event.target
      if (!(target instanceof Element)) return
      const closer = target.closest("[data-giveaway-close]")
      if (closer) {
        event.preventDefault()
        const dialog = closer.closest("dialog")
        if (dialog instanceof HTMLDialogElement) dialog.close()
        return
      }
      const trigger = target.closest("[data-giveaway-open]")
      if (!(trigger instanceof HTMLElement)) return
      event.preventDefault()
      event.stopPropagation()
      const name = trigger.getAttribute("data-giveaway-open")
      const dialog = dialogs.find((item) => item.getAttribute("data-giveaway-dialog") === name)
      if (!(dialog instanceof HTMLDialogElement)) return
      if (!dialog.contains(trigger)) opener = trigger
      for (const other of dialogs) {
        if (other !== dialog && other.open) other.close()
      }
      if (!dialog.open) dialog.showModal()
      document.documentElement.style.overflow = "hidden"
      const closeButton = dialog.querySelector("[data-giveaway-close]")
      if (closeButton instanceof HTMLElement) closeButton.focus()
    })
  }

  function closedMessage(state) {
    if (state === "early") return "Entries are not open yet."
    if (state === "ended") return "The entry window has ended."
    if (state === "unpublished") return "Entries are not open yet."
    return "Entries are closed."
  }

  function applyPublicCopy(root, payload) {
    if (!payload || payload.state === "unpublished") return
    const link = root.querySelector("[data-giveaway-instagram]")
    if (link instanceof HTMLAnchorElement && payload.instagramUrl) link.href = payload.instagramUrl
  }
})()
